import { useMemo } from 'react';
import useValidator from '../../../../../utilities/useValidator';
import validators from '../../../../../utilities/validators';

const useBookingFormValidator = (validateBookingCode: boolean) => {
    const validator = useMemo(
        () =>
            validators.compose(
                validators.requiredValue('rentalPeriod'),
                validators.requiredValue('startTime'),
                validators.requiredValue('endTime'),
                validators.requiredString('location'),
                validators.timeChecker('endTime'),
                validators.only(() => validateBookingCode, validators.requiredString('bookingCode'))
            ),
        [validateBookingCode]
    );

    return useValidator(validator);
};

export default useBookingFormValidator;
